import Sentry from '../../sentry-logging';
import { UserRole } from '../enums/auth';
import { WebViewEvents } from '../enums/webViewEvents';

export const sendEventToReactNative = (
  event: WebViewEvents,
  role?: UserRole,
  data?: any,
) => {
  const params: Record<string, any> = {};
  if (role) {
    params['role'] = role;
  }
  if (data) {
    params['data'] = data;
  }

  try {
    window?.ReactNativeWebView?.postMessage(
      JSON.stringify({ action: event, ...params }),
    );
  } catch (error) {
    Sentry.captureException(error);
  }
};

export const isReactNative = navigator.userAgent === 'ReactNative';
